type ProgressRingProps = {
    size?: number // svg width/height
    radius?: number
    pct: number
    strokeWidth?: number
    bgStroke?: string
    progressStroke?: string
    className?: string
    transformRotate?: number
}

export default function ProgressRing({
    size = 40,
    radius,
    pct,
    strokeWidth = 4,
    bgStroke = '#E6EDF0',
    progressStroke = '#16A34A',
    className = '',
    transformRotate = -90,
}: ProgressRingProps) {
    const r = radius ?? (size - strokeWidth) / 2
    const circumference = 2 * Math.PI * r
    const dashoffset = circumference * (1 - Math.max(0, Math.min(100, pct)) / 100)
    const viewBox = `0 0 ${size} ${size}`
    const cx = size / 2
    const cy = size / 2

    return (
        <svg className={className} width={size} height={size} viewBox={viewBox} aria-hidden>
            <circle cx={cx} cy={cy} r={r} stroke={bgStroke} strokeWidth={strokeWidth} fill="transparent" />
            <circle
                cx={cx}
                cy={cy}
                r={r}
                stroke={progressStroke}
                strokeWidth={strokeWidth}
                fill="transparent"
                strokeLinecap="round"
                strokeDasharray={circumference}
                strokeDashoffset={dashoffset}
                transform={`rotate(${transformRotate} ${cx} ${cy})`}
                className="transition-[stroke-dashoffset] duration-600 ease-out"
            />
        </svg>
    )
}
